export enum PersonaliseSetupScreens {
  Overview = 'Dashboard',
  SkillLevel = 'SkillLevel',
  Equipment = 'Equipment',
  WorkoutType = 'WorkoutType',
  BodyGroup = 'BodyGroup',
  BagContact = 'BagContact',
}
